import styled, { css } from 'styled-components'

import useViewportType from '@hooks/useViewport/useViewportType'
import Blink from '@components/Blink'
import SummaryPill from '@components/Summary/SummaryPill'

import { AnswerParagraphProps } from '../types'
import TypingAnimationWrapper from './TypingEffectWrapper'

import type { FunctionComponent } from 'react'

const StyledParagraph = styled.p`
  ${({
    theme: {
      typography: {
        bodycopy: {
          small2: { bundledCSS: small2BodycopyCSS },
        },
      },
      spacing: { spacing8 },
    },
  }) => css`
    ${small2BodycopyCSS};
    margin: 0;
    min-height: 16px;
    padding: ${spacing8} 0 ${spacing8} 0;
    &:first-child {
      padding: 0 0 ${spacing8} 0;
    }
  `}
`

const StyledPillWrapper = styled(Blink)`
  ${({
    theme: {
      colors: { fillBrandHover },
    },
  }) => css`
    position: relative;
    top: -3px;
    cursor: pointer;

    &:hover {
      span {
        background-color: ${fillBrandHover};
      }
    }
  `}
`

const AnswerParagraph: FunctionComponent<AnswerParagraphProps> = ({
  linkItem,
  contentItem,
  popoverParentRef,
  skipAnimation,
  trackPillClick,
  setActiveIndex,
  afterTypingEffectEndCb,
}) => {
  const viewportType = useViewportType()
  const isMobile = viewportType === 'mobile'

  const onPillClick = (url: string) => {
    if (isMobile) {
      const activeIndex = parseInt(contentItem.link ?? '')

      if (isNaN(activeIndex) || activeIndex === null) {
        setActiveIndex(null)
        return
      }

      setActiveIndex(activeIndex - 1)
    } else {
      trackPillClick?.(url)
    }
  }

  return (
    <StyledParagraph key={contentItem.text}>
      <TypingAnimationWrapper
        text={contentItem.text}
        skipAnimation={skipAnimation}
        afterText={
          <>
            {linkItem && (
              <>
                &nbsp;
                <StyledPillWrapper
                  onClick={() => onPillClick(linkItem.url)}
                  href={new URL(linkItem.url).pathname}
                >
                  <SummaryPill
                    tooltipItem={linkItem}
                    onTooltipClick={() => trackPillClick?.(linkItem.url)}
                    popoverParentRef={popoverParentRef}
                  >
                    {contentItem.link}
                  </SummaryPill>
                </StyledPillWrapper>
              </>
            )}
          </>
        }
        afterTypingEffectEndCb={afterTypingEffectEndCb}
      />
    </StyledParagraph>
  )
}

export default AnswerParagraph
